export const manualSeparationMessages = {
  en: {
    pageTitle: 'Manual Site Separation',
    btnApply: 'Apply',
    newSiteNameColumnTitle: 'New Site',
    addToSiteDialog: {
      title: 'Change site',
      btnClose: 'Close',
      btnChange: 'Change site',
      siteName: 'Site name',
      required: 'Site name is required',
    },
    confirmDialog: {
      header: 'Where do you want to change the site name attribute?',
      subHeader: 'The entire topology will be recalculated',
      btnConfirm: 'Current snapshot',
      btnSecondaryConfirm: 'Current & Future snapshots',
    },
    leaveDialog: {
      btnSave: 'Apply',
      btnLeave: 'Leave',
      header: 'Site changes are not applied',
      subHeader: 'So you really want to leave?',
    },
    request: {
      settingsApplied: 'Rebuilding network topology has been started',
    },

    // used only for old page
    row: 'row',
    rows: 'rows',
    selectedDevices:
      'Selected {selectedDevices} from total {totalDevices} rows',
    disabledTitle: 'Manual Separation Disabled',
    disabledLink: 'Enable manual separation',
    // table msg
    boxTitle: 'Device Inventory',
    boxHelpText: '',
    columns: {
      siteName: { name: 'Site', help: 'Device site location' },
      newSiteName: {
        name: 'New Site',
        help: 'Site name where the device will be moved',
      },
      hostname: { name: 'Hostname', help: 'Device name' },
      sn: { name: 'Serial Number', help: 'Serial number of the device' },
      loginIp: {
        name: 'Login IP',
        help: 'IP address for administrative access to the device',
      },
      loginType: {
        name: 'Management Protocol',
        help: 'Protocol used to connect to the device. This can be either "ssh" (preferred) or "telnet".',
      },
      version: {
        name: 'Version',
        help: 'The operating system version the device is running',
      },
      vendor: { name: 'Vendor', help: 'Vendor of the device' },
      family: { name: 'Family', help: 'Software family of the device' },
    },
  },
};
